module.exports = __webpack_public_path__ + "img/bask_left_sel.4a37ef0d.png";